var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",class:['form-control', (_vm.$parent.$parent.hasErrors && !_vm.$parent.$parent.isValid) ? 'is-invalid' : ''],attrs:{"disabled":_vm.disabled,"type":"number","step":"any","placeholder":"placeholder"},domProps:{"value":_vm.numericValue},on:{"input":function($event){return _vm.inputHandler($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }